import React from 'react';
import styles from './style.module.css';
import {
  CyclingIcon,
  RunningIcon,
  SwimmingIcon,
  VirtualRideIcon,
} from '../icons';

type ButtonToggleProps = {
  active: boolean;
  onClick: () => void;
  label: 'cycling' | 'running' | 'swimming' | 'virtual ride';
  colorClass: string;
};

const ButtonToggle = ({
  active,
  onClick,
  label,
  colorClass,
}: ButtonToggleProps) => {
  const icon = (() => {
    switch (label) {
      case 'cycling':
        return <CyclingIcon className={styles.icon} />;
      case 'running':
        return <RunningIcon className={styles.icon} />;
      case 'swimming':
        return <SwimmingIcon className={styles.icon} />;
      case 'virtual ride':
        // Assuming you want to use the same icon for virtual ride as cycling
        return <VirtualRideIcon className={styles.icon} />;
      default:
        return null;
    }
  })();

  return (
    <button
      type="button"
      className={`${styles.toggleButton} ${active ? styles[colorClass] : styles.inactiveButton}`}
      onClick={onClick}
    >
      {icon} <span style={{ marginLeft: '5px' }}>{label}</span>
    </button>
  );
};

export default ButtonToggle;
